const dtf = new Intl.DateTimeFormat("en-US", {
  timeZone: "America/New_York",
  timeZoneName: "short",
});

export function getEasternTimeZone(date = new Date()) {
  const dateTime = dtf.formatToParts(date);

  const timeZone = dateTime.find((p) => p.type === "timeZoneName");

  return timeZone ? timeZone.value : "";
}
